import s from "./RegisterDetailPage.module.css";
import { useEffect, useState } from "react";

import { googleProvider } from "../../firebase/config";
import { useSocialSignup } from "../../hooks/useSocialSignup";

import ProgressBar from "components/ProgressBar";
import { useLocation, useNavigate } from "react-router-dom";
import { SvgGoogle, SvgGoogleDisabled } from "assets/svg";
import { useAuthContext } from "context/AuthContext";
import axios from "axios";
import cn from "classnames";

function RegisterDetailPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const fullName = location.state?.fullName || "";
  const age = location.state?.age || 0;
  const timeZone = location.state?.timeZone || null;
  const google = useSocialSignup(googleProvider);

  const [description, setDescription] = useState("");

  const { user } = useAuthContext();

  useEffect(() => {
    if (user && user.hasOwnProperty("description")) {
      setDescription(user.description);
    }
  }, [user]);

  const handleDescription = (e) => {
    setDescription(e.target.value);
  };

  const handlePrevStep = () => {
    navigate("/register_basic");
  };

  const handleLogin = async (e) => {
    if (fullName !== "" && age !== "") {
      e.preventDefault();
      const userData = {
        name: fullName,
        age: parseInt(age),
        description: description,
        timezone: timeZone?.label,
        off_set: timeZone?.off_set,
      };
      google.signInWithSocial(userData);
    }
  };

  return (
    <div className={s.root}>
      <ProgressBar step={2} handlePrevStep={handlePrevStep} />
      <div className={s.content}>
        Why did you decide to participate in the challenge?
      </div>
      <form className="w-full md:w-[600px]">
        <div className={s.bottomContent}>
          <div className="w-full">
            <textarea
              rows={4}
              type="text"
              placeholder="Why did you decide to participate in the challenge?"
              value={description}
              onChange={handleDescription}
              className={s.textField}
              required
            />
            <div
              className={`w-full text-right ${
                description.length > 500 && "text-[#f00]"
              }`}
            >
              {description.length}/500
            </div>
          </div>
        </div>
        <div
          onClick={handleLogin}
          className="fixed bottom-[32px] w-[calc(100%_-_64px)] md:w-[600px]"
        >
          {description.length > 500 ? (
            <button
              className={cn(s.loginButton)}
              style={{ borderColor: "#777", opacity: "0.7", color: "#777" }}
              disabled={true}
            >
              <SvgGoogleDisabled />
              Continue with Google
            </button>
          ) : (
            <button className={cn(s.loginButton)}>
              <SvgGoogle />
              Continue with Google
            </button>
          )}
        </div>
      </form>
    </div>
  );
}

export default RegisterDetailPage;
